import { render, staticRenderFns } from "./validation-issues-button.vue?vue&type=template&id=2e1d1484&scoped=true&"
import script from "./validation-issues-button.vue?vue&type=script&lang=js&"
export * from "./validation-issues-button.vue?vue&type=script&lang=js&"
import style0 from "./validation-issues-button.vue?vue&type=style&index=0&id=2e1d1484&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d1484",
  null
  
)

export default component.exports